import { CabinetCard, Card } from "@/components/Card";
import { BulkExport } from "@/components/BulkExport";
import { RootState, useAppDispatch } from "@/store";
import { useEffect, useState } from "react";
import { useSubAccount } from "@/hooks";
import {
  exportEarningXls,
  getSubAccountEarnings$,
  setLoading,
} from "@/store/sub_accounts";
import { useSelector } from "react-redux";
import { CustomTable } from "@/components/Table/CustomTable";
import { Button, Spinner } from "react-bootstrap";
import { toDate } from "@/utils";
import { formatHash } from "@/utils/to-hash";
import { useTranslations } from "use-intl";
import { PickDate } from "@/features/ui/pick-date";
import { subDays } from "date-fns";

export default function Earnings() {
  const dispatch = useAppDispatch();
  const i18n = useTranslations("cabinet");
  const earnings = useSelector((state: RootState) => state.subAccount.earnings);
  const [loadingXls, setLoadingXls] = useState(false);
  const [date, setDate] = useState({
    from: subDays(new Date(), 30),
    to: new Date(),
  });
  const { currentSubAccount, loading, currentSubAccountInfo } = useSubAccount();
  useEffect(() => {
    let promise: any;
    if (currentSubAccount) {
      dispatch(setLoading(true));
      promise = dispatch(
        getSubAccountEarnings$({
          sub_account_name: currentSubAccount,
          start_date: date?.from?.toISOString().split("T")[0] || null,
          end_date: date?.to?.toISOString().split("T")[0] || null,
        }),
      );
    }
    return () => {
      dispatch(setLoading(false));
      if (promise) {
        promise.abort();
      }
    };
  }, [currentSubAccount, date]);
  return (
    <>
      {loading ? (
        <Spinner animation={"grow"} />
      ) : (
        <>
          <div className={"d-flex justify-content-end w-100 mb-4"}>
            <PickDate
              defaultDate={date}
              onChange={(val) => {
                setDate(val);
              }}
            />
            {loadingXls ? (
              <Spinner />
            ) : (
              <Button
                onClick={() => {
                  setLoadingXls(true);
                  exportEarningXls({
                    sub_account_name: currentSubAccount,
                    start_date: date?.from?.toISOString().split("T")[0] || null,
                    end_date: date?.to?.toISOString().split("T")[0] || null,
                  }).then(() => setLoadingXls(false));
                }}
              >
                {i18n("earnings.exportXls")}
              </Button>
            )}
            <div className={"ms-3"}>
              <BulkExport kind={"earnings"} />
            </div>
          </div>
          <CabinetCard className={"mb-[20px]"}>
            <CustomTable
              notFoundText={i18n("notFoundText")}
              headers={[
                i18n("earnings.header.date"),
                i18n("earnings.header.profit"),
                i18n("earnings.header.hashrate"),
                i18n("earnings.header.type"),
              ]}
              columns={earnings.map((earning) => {
                return {
                  data: [
                    toDate(earning.date),
                    (+earning.total_profit).toFixed(8),
                    formatHash(
                      earning.hashrate,
                      currentSubAccountInfo?.crypto_currency,
                    ),
                    i18n(`earnings.type.${earning.type ?? "earning"}`),
                  ],
                };
              })}
            />
          </CabinetCard>
        </>
      )}
    </>
  );
}
